import DotLine from './DotLine';
import RightArrow from './RightArrow';
import SincronizedArrows from './SincronizedArrows';
import UpAndDownArrows from './UpAndDownArrows';
import GenericAsset from './GenericAsset';
import Placeholder from './Placeholder';

const assets = {
  dotLine: DotLine,
  rightArrow: RightArrow,
  sincronizedArrows: SincronizedArrows,
  upAndDownArrows: UpAndDownArrows,
  genericAsset: GenericAsset,
  placeholder: Placeholder,
};

export default assets;
